import { render, staticRenderFns } from "./ScheduleHolidayOverview.vue?vue&type=template&id=6d6729be&scoped=true&"
import script from "./ScheduleHolidayOverview.vue?vue&type=script&lang=js&"
export * from "./ScheduleHolidayOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6729be",
  null
  
)

export default component.exports